import '@ui5/webcomponents/dist/ProgressIndicator.js';
import { ValueState } from '../../enums';
import { withWebComponent } from '../../internal/withWebComponent';
/**
 * Shows the progress of a process in a graphical way. To indicate the progress, the inside of the component is filled with a color.
 *
 * <ui5-link href="https://sap.github.io/ui5-webcomponents/playground/components/ProgressIndicator" target="_blank">UI5 Web Components Playground</ui5-link>
 */
const ProgressIndicator = withWebComponent('ui5-progress-indicator', ['displayValue', 'value', 'valueState'], ['disabled', 'hideValue'], [], []);
ProgressIndicator.displayName = 'ProgressIndicator';
ProgressIndicator.defaultProps = {
    value: 0,
    valueState: ValueState.None
};
export { ProgressIndicator };
